import React from 'react';
import { bool } from 'prop-types';

import { compose } from 'redux';
import { connect } from 'react-redux';
import config from '../../config';
import { injectIntl, FormattedMessage } from '../../util/reactIntl';
import {
  LayoutSingleColumn,
  LayoutWrapperTopbar,
  LayoutWrapperMain,
  LayoutWrapperFooter,
  Footer,
  ExternalLink,
  NamedLink,
} from '../../components';
import StaticPage from '../../containers/StaticPage/StaticPage';
import TopbarContainer from '../../containers/TopbarContainer/TopbarContainer';

import css from './AboutPage.module.css';
import image from './crops-about.png';

const AboutPageComponent = props => {
  const { intl, isAuthenticated } = props;
  const { siteInstagramPage, siteFacebookPage } = config;

  const accountLink = (
    <NamedLink name={isAuthenticated ? 'ManageListingsPage' : 'SignupPage'}>
      <FormattedMessage id="AboutPage.accountLink" />
    </NamedLink>
  );

  const emailLink = <a href="mailto:mail@cropsie.com">mail@cropsie.com</a>;
  const facebook = <ExternalLink href={siteFacebookPage}>Facebook</ExternalLink>;
  const instagram = <ExternalLink href={siteInstagramPage}>Instagram</ExternalLink>;

  // prettier-ignore
  return (
    <StaticPage
      title="About Us"
      schema={{
        '@context': 'http://schema.org',
        '@type': 'AboutPage',
        description: intl.formatMessage({ id: 'AboutPage.heading' }),
        name: intl.formatMessage({ id: 'AboutPage.title' }),
      }}
    >
      <LayoutSingleColumn>
        <LayoutWrapperTopbar>
          <TopbarContainer />
        </LayoutWrapperTopbar>

        <LayoutWrapperMain>
          <div className={css.root}>
            <div className={css.header}>
              <FormattedMessage id="AboutPage.title" />
            </div>
            <div className={css.staticPageWrapper}>
              <div className={css.pageContent}>
                <h1 className={css.pageTitle}>
                  <FormattedMessage id="AboutPage.heading" />
                </h1>
                <img className={css.coverImage} src={image} alt="My first ice cream." />

                <div className={css.contentMain}>
                  <h2>
                    <FormattedMessage id="AboutPage.subheading" />
                  </h2>

                  <p>
                    <FormattedMessage id="AboutPage.body1" />
                  </p>

                  <h3 className={css.subtitle}>
                    <FormattedMessage id="AboutPage.helpTitle" />
                  </h3>

                  <p>
                    <FormattedMessage id="AboutPage.body2" values={{ account: accountLink }} />
                  </p>

                  <h3 id="contact" className={css.subtitle}>
                    <FormattedMessage id="AboutPage.contactTitle" />
                  </h3>

                  <p>
                    <FormattedMessage id="AboutPage.contactBody" values={{ email: emailLink }} />
                  </p>
                  <p>
                    <FormattedMessage id="AboutPage.contactSocial" values={{ facebook, instagram }} />
                  </p>
                </div>
              </div>
            </div>
          </div>
        </LayoutWrapperMain>

        <LayoutWrapperFooter>
          <Footer />
        </LayoutWrapperFooter>
      </LayoutSingleColumn>
    </StaticPage>
  );
};

AboutPageComponent.propTypes = { isAuthenticated: bool.isRequired };

const mapStateToProps = state => {
  const { isAuthenticated } = state.Auth;
  return { isAuthenticated };
};

const AboutPage = compose(
  connect(mapStateToProps),
  injectIntl
)(AboutPageComponent);

export default AboutPage;
